module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.listOfComments), function(comment, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          !comment.is_hidden ||
          _vm.hasTeacherPermissionsInCourse ||
          _vm.owncomment(comment.user_id, comment.anonymous_identity_id)
        ),
        expression: "\n      !comment.is_hidden ||\n      hasTeacherPermissionsInCourse ||\n      owncomment(comment.user_id, comment.anonymous_identity_id)\n    "
      }],
      key: index,
      staticClass: "flex px-5 py-6 w-full",
      class: [
        index !== _vm.listOfComments.length - 1 ?
        'border-b border-solid border-gray-200' :
        '',
        index === 0 && comment.is_model_submission === false ? 'pt-0' : '' ],
      attrs: {
        "id": ("individual-comment-" + (comment.id))
      }
    }, [_c('div', {
      staticClass: "w-full",
      class: _vm.$route.query.topLevelCommentID === comment.id &&
        !_vm.$route.query.replyCommentID &&
        _vm.isOpenReply === false ?
        'bg-pinky-light bg-opacity-10 p-5 border-2 border-pinky' :
        ''
    }, [_c('div', {
      class: comment.is_hidden ? 'hidden-record' : ''
    }, [_c('CommentCard', {
      staticClass: "text-md mb-6",
      attrs: {
        "submissionComment": comment
      }
    }), _vm._v(" "), (comment.children) ? _c('div', {
      staticClass: "ml-16"
    }, [(!_vm.is_report_page && !_vm.studentInHardClosedRT) ? _c('button', {
      staticClass: "mr-2 px-5 py-2 rounded cursor-pointer text-xs font-semibold text-blueGray-800 border border-solid",
      class: [_vm.selected_comment_id === comment.id ?
        'text-white border-blueGray-400' :
        'text-blueGray-800', _vm.fromGenieRecap && _vm.isGenieRecap ? 'bg-blueGray-200 hover:border-blueGray-400 border-blueGray-300 text-blueGray-600 hover:text-blueGray-900' : 'bg-gray-200 hover:border-gray-400 border-gray-300'
      ],
      attrs: {
        "id": ("comment-reply-" + (comment.id))
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleReplyField(comment.id, _vm.replysCount(comment.children))
        }
      }
    }, [_vm._v("\n            Replies (" + _vm._s(_vm.replysCount(comment.children)) + ")\n          ")]) : _c('button', {
      staticClass: "mr-2 px-5 py-2 rounded bg-gray-100 cursor-pointer text-xs font-semibold",
      class: [
        _vm.selected_comment_id === comment.id ?
        'text-white bg-blueGray-500' :
        'text-gray-400',
        comment.children.length === 0 ?
        'opacity-50 cursor-not-allowed' :
        'hover:text-white hover:bg-blueGray-500' ],
      attrs: {
        "disabled": comment.children.length === 0
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleReplyField(comment.id, _vm.replysCount(comment.children))
        }
      }
    }, [_vm._v("\n            Read Replies (" + _vm._s(comment.children.length) + ")\n          ")])]) : _vm._e()], 1), _vm._v(" "), (_vm.selected_comment_id === comment.id) ? _c('div', {
      staticClass: "w-full mt-7 bg-transparent"
    }, [_c('CommentReplies', {
      staticClass: "ml-12",
      attrs: {
        "commentReplyToHighlightID": _vm.commentReplyToHighlightID,
        "comment": comment
      }
    }), _vm._v(" "), (!_vm.is_report_page && !_vm.studentInHardClosedRT) ? _c('div', {
      staticClass: "w-full flex justify-between pr-5 pl-16 pb-8",
      class: [
        _vm.fromGenieRecap && _vm.isGenieRecap ? 'bg-blueGray-100' : 'bg-gray-100' ]
    }, [_c('div', {
      staticClass: "w-full bg-white rounded focus-within:border-primary border border-coolGray-100"
    }, [_c('Textbox', {
      ref: "reply-textbox",
      refInFor: true,
      attrs: {
        "selectedRef": "reply-textbox",
        "autoSave": true,
        "id": ("reply-textbox-" + (comment.id)),
        "showSubmitButton": false,
        "placeholder": "Write a reply",
        "maxHeight": 85
      },
      on: {
        "messageSent": function($event) {
          return _vm.submitReply(comment.id)
        },
        "saveChanges": function($event) {
          return _vm.saveChanges(comment.id)
        }
      },
      model: {
        value: (_vm.reply_content),
        callback: function($$v) {
          _vm.reply_content = $$v
        },
        expression: "reply_content"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex relative justify-between items-center border-t border-coolGray-200 py-3 px-3"
    }, [_c('EmojiPicker', {
      staticClass: "emoji-container",
      attrs: {
        "search": _vm.searchEmoji
      },
      on: {
        "emoji": _vm.append
      },
      scopedSlots: _vm._u([{
        key: "emoji-invoker",
        fn: function(ref) {
          var clickEvent = ref.events.click;

          return _c('div', {
            staticClass: "emoji-invoker",
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return clickEvent.apply(null, arguments)
              }
            }
          }, [_c('button', {
            staticClass: "w-8 h-8 hover:bg-coolGray-200 rounded-full"
          }, [_c('i', {
            staticClass: "fa-solid text-base text-gray-500 fa-face-grin"
          })])])
        }
      }, {
        key: "emoji-picker",
        fn: function(ref) {
          var emojis = ref.emojis;
          var insert = ref.insert;

          return _c('div', {}, [_c('div', {
            staticClass: "emoji-picker absolute w-80 h-56 px-5 shadow rounded border border-coolGray-300 py-4 z-50 overflow-x-hidden overflow-y-auto bg-white"
          }, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.searchEmoji),
              expression: "searchEmoji"
            }],
            staticClass: "py-2 px-4 rounded w-full border-2 border-red-500",
            attrs: {
              "placeholder": "Search",
              "type": "text"
            },
            domProps: {
              "value": (_vm.searchEmoji)
            },
            on: {
              "input": function($event) {
                if ($event.target.composing) { return; }
                _vm.searchEmoji = $event.target.value
              }
            }
          }), _vm._v(" "), _c('div', _vm._l((emojis), function(emojiGroup, category) {
            return _c('div', {
              key: category
            }, [_c('h5', [_vm._v(_vm._s(category))]), _vm._v(" "), _c('div', {
              staticClass: "emojis"
            }, _vm._l((emojiGroup), function(emoji, emojiName) {
              return _c('span', {
                key: emojiName,
                attrs: {
                  "title": emojiName
                },
                on: {
                  "click": function($event) {
                    return insert(emoji)
                  }
                }
              }, [_vm._v(_vm._s(emoji))])
            }), 0)])
          }), 0)])])
        }
      }], null, true)
    }), _vm._v(" "), _c('button', {
      staticClass: "sample py-2 w-28 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
      attrs: {
        "disabled": _vm.submitting
      },
      on: {
        "click": function($event) {
          return _vm.submitReply(comment.id)
        }
      }
    }, [_vm._v("\n                Send\n              ")])], 1)], 1)]) : _vm._e()], 1) : _vm._e()])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-390980e9!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/commentCardList.vue
// module id = 1097
// module chunks = 61